import createReactComponent from '../createReactComponent';
export default createReactComponent('maximize-one', 'MaximizeOne', [["path",{"d":"M14 4h6v6M10 20H4v-6M20 4l-6 6M4 20l6-6","key":"svg-0"}]]);